import { render, staticRenderFns } from "./_HealthCash.vue?vue&type=template&id=54440875&"
import script from "./_HealthCash.vue?vue&type=script&lang=js&"
export * from "./_HealthCash.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports